
import React from 'react';
import { motion } from 'framer-motion';
import { WHATSAPP_URL } from '../constants';

const WhatsAppButton: React.FC = () => {
  return (
    <>
      {/* Desktop Floating Button */}
      <motion.a 
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="hidden md:flex fixed bottom-8 right-8 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-2xl items-center justify-center group"
        initial={{ scale: 0, rotate: -45 }}
        animate={{ scale: 1, rotate: 0 }}
        whileHover={{ scale: 1.15 }}
        whileTap={{ scale: 0.9 }}
      >
        <motion.div
          className="absolute inset-0 bg-[#25D366] rounded-full"
          animate={{ scale: [1, 1.4, 1], opacity: [0.5, 0, 0.5] }}
          transition={{ repeat: Infinity, duration: 2 }}
        />
        <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 font-bold whitespace-nowrap mr-0 group-hover:mr-2 relative z-10">
          Consultar Oferta
        </span>
        <i className="fa-brands fa-whatsapp text-3xl relative z-10"></i>
      </motion.a>

      {/* Mobile Sticky CTA */}
      <motion.div 
        className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white p-4 border-t border-slate-200 shadow-[0_-10px_25px_-3px_rgba(0,0,0,0.1)]"
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        transition={{ type: "spring", damping: 20, stiffness: 100 }}
      >
        <motion.a 
          href={WHATSAPP_URL}
          className="bg-[#25D366] text-white w-full py-4 rounded-xl font-bold flex items-center justify-center gap-2 shadow-lg"
          animate={{ scale: [1, 1.02, 1] }}
          transition={{ repeat: Infinity, duration: 3 }}
        >
          <i className="fa-brands fa-whatsapp text-xl"></i>
          <span>Comprar Ahora por WhatsApp</span>
        </motion.a>
      </motion.div>
    </>
  );
};

export default WhatsAppButton;